// AlertsStore.js

import { writable, get } from 'svelte/store';        // this now has set() update() and subscribe() methods

export const storeAlert = writable(null);
export const isCancelled = writable(false);

export const ERROR = 'error';
export const WARNING = 'warning';
export const INFO = 'info';
export const TEXT = 'text';

let timeout = null;

const setAlert = (alertObj, msecs, callback) => {
    storeAlert.set(null);
    storeAlert.set(alertObj);
    isCancelled.set(false);
    if (msecs > 0) {
        timeout = setTimeout(() => {
            clearAlert();
            clearTimeout(timeout);
            if (callback && !get(isCancelled)) callback();
        }, msecs)    
    } else {
        if (callback && !get(isCancelled)) callback();
    }
}


// convenience functions

export const setErrorAlert = (message, msecs = 0, callback = null) => {
    setAlert({type: ERROR, message: message}, msecs, callback);
}

export const setWarningAlert = (message, msecs = 0, callback = null) => {
    setAlert({type: WARNING, message: message}, msecs, callback);
}

export const setInfoAlert = (message, msecs = 0, callback = null) => {
    setAlert({type: INFO, message: message}, msecs, callback);
}

export const setTextAlert = (message, msecs = 0, callback = null) => {
    setAlert({type: TEXT, message: message}, msecs, callback);
}

export const clearAlert = () => {
    storeAlert.set(null);
}


// includes both error and success messages
export const FETCH_REVIEWS_ERROR = "There was an error while fetching the requested services.";
export const APPROVAL_ERROR_MSG = "There was an error while processing your request.";

export const PENDING_MSECS = 3000;
